import React, { Fragment } from'react';
import propTypes from 'prop-types';
import { Input, Select } from 'react-nice-inputs';

import InputAid from 'js/components/step4/InputAid';

const StateInput = ({ stateInputType, type = '', suffix = '', index = '', isDisabled = false, states, value = '', countryValue, onChange, validations = {}, classList, section = 'guests', placeholder }) => {

  let currentCountry = countryValue || '';

  currentCountry = currentCountry.toLowerCase() || currentCountry;

  return (
    <Fragment>
      { stateInputType === '' &&
        <div className="input disabled country-placerholder">Select a country first...</div>
      }
      { stateInputType === 'dd' &&
        <Select name={ (section === 'guests' && currentCountry !== 'us') ? `province_${ type }${ suffix }` : `state_${ type }${ suffix }` }
          classList={ classList }
          onChange={ (val, name, e) => { onChange(val, name, e); } }
          options={ states }
          defaultText={ currentCountry === 'us' ? 'Select a State' : 'Select a Province'}
          attrs={ { 'data-guestid': index, disabled: isDisabled, placeholder } }
          value={ value.toLowerCase() }
        />
      }
      { stateInputType === 'txt' &&
        <Input type="text"
          name={ (section === 'guests' && currentCountry !== 'us') ? `province_${ type }${ suffix }` : `state_${ type }${ suffix }` }
          classList={ classList }
          onChange={ (val, name, e) => { onChange(val, name, e); } }
          attrs={ { 'data-guestid': index, maxLength: 20, disabled: isDisabled, placeholder } }
          value={ value }
        />
      }

      { validations[`state_${ type }${ suffix }`] &&
        <InputAid validation={ validations[`state_${ type }${ suffix }`]} />
      }
      { validations[`province_${ type }${ suffix }`] &&
        <InputAid validation={ validations[`province_${ type }${ suffix }`]} />
      }
    </Fragment>
  );
};

StateInput.propTypes = {
  stateInputType: propTypes.string,
  type: propTypes.string,
  suffix: propTypes.string,
  index: propTypes.string,
  onChange: propTypes.func,
  states: propTypes.array,
  validations: propTypes.object,
  classList: propTypes.array
};

export default StateInput;



// WEBPACK FOOTER //
// ./js/components/step4/StateInput.js